import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/homeData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between h-16 md:h-[72px] px-4 md:px-10">
        <h1 className="flex items-center">
          <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
            <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center">
              <i className="ri-fire-line text-background-50 text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading text-lg md:text-xl font-bold tracking-wide ${
                  scrolled ? "text-foreground-950" : "text-background-50"
                }`}
              >
                黑料一区
              </span>
              <span
                className={`text-[10px] tracking-[0.28em] mt-1 ${
                  scrolled ? "text-foreground-500" : "text-background-200"
                }`}
              >
                GUA · RANK
              </span>
            </span>
          </a>
        </h1>

        <nav className="hidden md:flex items-center gap-9">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`text-sm whitespace-nowrap cursor-pointer transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600"
                  : "text-background-100 hover:text-background-50"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#ranking"
            className="hidden sm:inline-flex items-center gap-1.5 whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 text-sm px-4 py-2 rounded-md cursor-pointer transition-colors"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-fire-line text-sm"></i>
            </span>
            进区吃瓜
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((prev) => !prev)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-md cursor-pointer ${
              scrolled
                ? "text-foreground-950 bg-background-100"
                : "text-background-50 bg-foreground-950/30"
            }`}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-2">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="block py-2.5 text-sm text-foreground-800 border-b border-background-100 last:border-0 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}